import controller from './audio-player.controller'
import template from './audio-player.html'

export default {
  template,
  controller
}
